{
    "goth": {
        "position": {
            "x": 10,
            "y": 6,
            "z": 1
        },
        "key": "goth",
        "affiliation": "good"
    }
}